/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function toggleSubscriptionOptions() {
    $('.product__subs__option').click(function(){
        $('.product__subs__group').removeClass('selected');
        $(this).closest('.product__subs__group').addClass('selected');
        $('.radio--select').removeClass('active');
    }); 
    $('.radio--select label').click(function(){
      $(this).parent().removeClass('active');
    }); 
    $('.radio--select .trigger').click(function(){
      $(this).parent().addClass('active');
    }); 
  }

  if ($('.radio--select').length > 0) { 
    toggleSubscriptionOptions();
  }


  function addClassinView() {
    const inViewport = (elem) => {
      let allElements = document.getElementsByTagName(elem);
      let windowHeight = window.innerHeight * .6;
      const elems = () => {
          for (let i = 0; i < allElements.length; i++) {  //  loop through the sections
              let viewportOffset = allElements[i].getBoundingClientRect();  //  returns the size of an element and its position relative to the viewport
              let top = viewportOffset.top;  //  get the offset top
              if(top < windowHeight){  //  if the top offset is less than the window height
                  allElements[i].classList.add('in-view');  //  add the class
              } else{
                  //allElements[i].classList.remove('in-view');  //  remove the class
              }
          }
      }
      elems();
      window.addEventListener('scroll', elems);
    }

    inViewport('.animated--content');  //  run the function on all section elements
  }

  addClassinView();


  function hotColdTabs() {
    $('.hot--cold--button').click(function(){
        console.log('click')
        var data          = $(this).attr('data-control');
        var allButtons    = $(this).closest('.hot--cold--container').find('.hot--cold--button');
        var allImages     = $(this).closest('.hot--cold--container').find('.hot--cold');
        var allLifestyle  = $(this).closest('.hot--cold--container').find('.hot--cold--lifestyle--image');
  
        var dataMatch     = $('.hot--cold--container *').find("[data-control='" + data + "']"); ;
  
        $(allButtons).removeClass('active');
        $(allImages).removeClass('active');
        $(allLifestyle).removeClass('active');
        $(this).addClass('active');
        $(dataMatch).addClass('active');
    }); 
  }

  hotColdTabs();

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


// document.addEventListener("DOMContentLoaded", function() {
//   document.querySelectorAll('.product-form').forEach(function(form) {
//     form.addEventListener('submit', function(event) {
//       event.preventDefault();

//       var formData = new FormData(form);
//       var xhr = new XMLHttpRequest();
//       xhr.open('POST', form.action, true);
//       xhr.onload = function() {
//         if (xhr.status >= 200 && xhr.status < 400) {
//           window.location.href = '/checkout';
//         } else {
//           alert('An error occurred while submitting the form.');
//         }
//       };
//       xhr.onerror = function() {
//         alert('An error occurred while submitting the form.');
//       };
//       xhr.send(formData);
//     });
//   });
// });





